import { render, staticRenderFns } from "./mailgun.vue?vue&type=template&id=489b2027&"
import script from "./mailgun.vue?vue&type=script&lang=js&"
export * from "./mailgun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports